import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";

export default function Transection() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);

    const { userToken } = useSelector((state) => state.user);

    const fetchPayments = async (pageNumber = page, limit = perPage) => {
        setLoading(true);

        try {
            const response = await fetch(
                "https://api.myad360.com/api/v1/FNV89uJ9sud/admin/get_payment_detail.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        token: userToken,
                    },
                    body: JSON.stringify({
                        page: pageNumber,
                        perpage: limit,
                    }),
                }
            );

            const result = await response.json();

            if (result?.data) {
                const formatted = result.data.map((item) => ({
                    ...item,
                    id: item.id,
                    fullName: item.full_name,
                    email: item.account_email,
                    method: item.payment_method,
                    date: item.created_date,
                }));

                setData(formatted);
                setTotalRows(Number(result.total_record) || formatted.length);
            }
        } catch (error) {
            console.error("Fetch error:", error);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchPayments(page, perPage);
    }, [page, perPage]);

    const handlePageChange = (newPage) => setPage(newPage - 1);
    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
        setPage(0);
    };

    // Normal method formatting
    const normalize = (method) =>
        method?.toLowerCase().replace(/\s+/g, "").trim();

    // Check if ALL rows are PayPal
    const isPayPalOnly = data.every(
        (item) => normalize(item.method) === "paypalaccount"
    );

    // Check if ANY bank transfer exists
    const hasBankTransfer = data.some(
        (item) => normalize(item.method) === "banktransfer"
    );

    // Base columns (always visible)
    const baseColumns = [
        { name: "Txn ID", selector: (row) => row.id },
        { name: "Full Name", selector: (row) => row.fullName },
        { name: "Email", selector: (row) => row.email },
        { name: "Method", selector: (row) => row.method },
        { name: "Date", selector: (row) => row.date },
    ];

    // Bank Transfer columns
    const bankColumns = [
        // { name: "Account", selector: (row) => row.account },
        { name: "Account Name", selector: (row) => row.title },
        { name: "Account Number", selector: (row) => row.account_number },
        { name: "Branch Address", selector: (row) => row.iban },
        // { name: "Swift Code", selector: (row) => row.swift_code },
        { name: "Bank Name", selector: (row) => row.bank_name },
        { name: "Branch", selector: (row) => row.branch },
        { name: "Country", selector: (row) => row.country },
        { name: "City", selector: (row) => row.city },
        {
            name: "IFSC_code", selector: (row) => row.ifsc_code
        },
    ];

    // FINAL COLUMNS (no empty space!)
    const columns = isPayPalOnly
        ? baseColumns // PayPal → show only 5 columns
        : hasBankTransfer
            ? [...baseColumns, ...bankColumns] // Bank → show all
            : baseColumns;

    const customStyles = {
        table: { style: { border: "1px solid #fdba74", borderRadius: "8px", overflow: "hidden" } },
        headRow: { style: { backgroundColor: "#fff7ed", borderBottom: "1px solid #fdba74" } },
        headCells: { style: { color: "#b45309", fontWeight: 700, fontSize: "0.86rem", textTransform: "uppercase", letterSpacing: "0.02em", borderRight: "1px solid #fed7aa" } },
        rows: { style: { minHeight: "52px", borderBottom: "1px solid #f3f4f6" } },
        cells: { style: { borderRight: "1px solid #f3f4f6", color: "#1f2937" } },
        pagination: { style: { borderTop: "1px solid #fed7aa", backgroundColor: "#fff" } },
    };

    return (
        <div
            style={{
                padding: "30px",
                background: "white",
                boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                margin: "20px",
            }}
        >
            <h2 style={{ marginBottom: "20px" }}>Transaction History</h2>

            <DataTable
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                highlightOnHover
                progressPending={loading}
            />
        </div>
    );
}
